// index.js
import generateOfferReducer from './reducers';
export { default as generateOfferOperations } from './operations';
export { default as generateOfferTypes } from './types';
export default generateOfferReducer;